<template>
  <div
    class="is-border vadTask has-background-white"
    @mouseover="hoverCard(true, 0)"
    @mouseout="hoverCard(false, 50)">
    <div class="columns">
      <div class="column is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <div class="columns">
          <div class="column is-narrow">
            <avatar
              :use-picto-custom="'fas fa-alarm-clock'"
              :force-picto="true"
              :is-avatar="false"
              :item="{}"
              class="has-background-danger is-medium has-text-white is-margin-top-xsmall">
            </avatar>
          </div>
          <div class="column">
            <p class="is-size-7 has-text-weight-light has-text-grey is-margin-top-xxsmall is-margin-bottom-xxsmall">
              <span>Aujourd’hui : {{ reminder.date | dtFormat('HH[h]mm') }}</span>
            </p>
            <p class="is-size-4">
              <router-link :to="{name: 'CalendarDay', params: { year: decomposedDate.year, month: decomposedDate.month, day: decomposedDate.day, panel: 'reminders' }}">
                <strong>Rappel</strong>
              </router-link>
              <span v-if="'program_name' in reminder.custom_fields && reminder.custom_fields.program_name && 'program_link' in reminder.custom_fields && reminder.custom_fields.program_link">
                —
                <router-link
                  class="is-hover-underline"
                  :to="{name: 'AdvInfos', params: {id: reminder.custom_fields.adv_link}}"
                  v-if="'adv_ref' in reminder.custom_fields && reminder.custom_fields.adv_ref && 'adv_link' in reminder.custom_fields && reminder.custom_fields.adv_link">
                  ADV : {{ reminder.custom_fields.adv_ref }}
                </router-link>
              </span>
              <span v-if="reminder.custom_fields.contactName && reminder.custom_fields.contactPk">
                —
                <router-link
                  class="is-hover-underline"
                  :to="{name: 'ContactVue', params: {id: reminder.custom_fields.contactPk}}">
                  {{ reminder.custom_fields.contactName }}
                </router-link>
              </span>
            </p>
            <p>
              <router-link :to="{name: 'CalendarDay', params: { year: decomposedDate.year, month: decomposedDate.month, day: decomposedDate.day, panel: 'reminders' }}">
                <span class="has-text-weight-normal is-size-5 is-hover-underline">
                  {{ reminder.title }}
                </span>
              </router-link>
            </p>
            <div
              v-if="reminder.note"
              class="columns is-multiline">
              <div class="column is-paddingless-bottom is-12 is-narrow">
                <span
                  class="has-text-weight-normal is-size-5 is-italic truncate"
                  v-html="reminder.note"></span>
              </div>
            </div>
            <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
              Auteur:
              <span
                class="has-text-weight-normal"
                v-if="reminder.author.pk === currentUser.pk">Vous</span>
              <span
                class="has-text-weight-normal"
                v-else>{{ reminder.author.last_name }} {{ reminder.author.first_name }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="column is-narrow is-w60p">
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 120, leave: 120 }"
          mode="out-in">
          <button
            @click="deleteReminder"
            v-show="isHover"
            class="button is-white is-size-7 is-min-width-0 is-radiusless is-height-full w100 tooltip is-tooltip-left has-text-grey is-border-left"
            data-tooltip="Supprimer">
            <span class="icon is-small"><i class="fas fa-times"></i></span>
          </button>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex/dist/vuex.esm.browser'
import moment from 'moment'

export default {
  name: 'ReminderCard',
  props: {
    reminder: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isHover: false,
      w: window,
      ticking: false,
      timer: null
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['currentUserPk']),
    /**
      * return moment() created_on
      * @return {string}
      */
    date () {
      return moment(this.reminder.date)
    },
    /**
      * reminder pk
      * @return {string}
      */
    reminderPK () {
      return this.reminder.pk
    },
    decomposedDate () {
      return {
        year: moment(this.reminder.date).format('YYYY'),
        month_styled: moment(this.reminder.date).format('MMMM'),
        month: moment(this.reminder.date).format('MM'),
        day: moment(this.reminder.date).format('DD')
      }
    }
  },
  methods: {
    hoverCard (isHover, delay = 100) {
      if (this.isHover === isHover) {
        this.w.clearTimeout(this.timer)
        this.isHover = isHover
        this.ticking = false
      } else if (!this.ticking) {
        // Si on quitte le card alors on met un delais avant la disparition du hover
        this.timer = this.w.setTimeout(() => {
          this.isHover = isHover
          this.ticking = false
        }, delay)
        this.ticking = true
      }
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rappel',
        text: 'Le rappel ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteReminder () {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = this.reminder.pk
        let key = moment(this.reminder.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.REMINDER, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'reminders' })
          this.$toasted.global.success('Le rappel à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
